import { Layout, DevicesSignalGroup } from "components"
export const Devices = () => {
 return (
  <Layout>
   <DevicesSignalGroup />
  </Layout>
 )
}
